import {
	resolveSurface,
	willComponentRender,
} from '@atlaskit/editor-ui-control-model/surface-renderer';
import type { SurfaceIdentifier } from '@atlaskit/editor-ui-control-model/surface-renderer/types';
import type { RegisterComponent, RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

export type TypeAheadMenuModel = {
	items: RegisterMenuItem[];
	root: RegisterComponent | undefined;
};

export const buildTypeAheadMenuModel = (
	components: RegisterComponent[],
	rootComponent: SurfaceIdentifier,
): TypeAheadMenuModel => {
	const { root, childrenMap, topLevelChildren } = resolveSurface(components, rootComponent);
	const items: RegisterMenuItem[] = [];

	for (const section of topLevelChildren ?? []) {
		if (section.type !== 'menu-section' || !willComponentRender(section, childrenMap)) {
			continue;
		}

		for (const child of childrenMap.get(section.key) ?? []) {
			if (child.type === 'menu-item' && willComponentRender(child, childrenMap)) {
				items.push(child);
			}
		}
	}

	return { items, root };
};
